import React, { useEffect, useRef, useState } from "react";
import {
  FaFacebook,
  FaInstagramSquare,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { FaBars } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import logos from "../assets/img/logos.png";
import play_btn from "../assets/img/play_btn.png";
import timg1 from "../assets/img/testimonial/t1.png";
import {
  default as timg2,
  default as timg4,
} from "../assets/img/testimonial/t2.png";
import timg3 from "../assets/img/testimonial/t3.png";
import thumbnail from "../assets/img/thumbnel.png";
import { default as logo_d, default as logo_w } from "../assets/svg/logo_w.svg";
import video from "../assets/video/video.mp4";
import "./style.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

export default function Home() {
  const [isActive, setIsActive] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleTogglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const images = [
    {
      timg: timg1,
    },
    {
      timg: timg2,
    },
    {
      timg: timg3,
    },
    {
      timg: timg4,
    },
    {
      timg: timg1,
    },
    {
      timg: timg2,
    },
    {
      timg: timg4,
    },
  ];

  return (
    <div className="homepage page">
      <div className={`navbar ${isScrolled ? "navbar-scrolled" : ""}`}>
        <div className="container">
          <Link to="/" className="logo_area">
            <img src={logo_w} className="logo logo-white m-0" alt="logo" />
            <img src={logo_d} className="logo logo-dark m-0" alt="logo" />
          </Link>
          <ul className={`nav_menu ${isActive ? "active" : ""}`}>
            <li className="nav_list">
              <Link to="" className="lav_link">
                Home
              </Link>
            </li>
            <li className="nav_list">
              <Link to="" className="lav_link">
                How it works
              </Link>
            </li>
            <li className="nav_list">
              <Link to="" className="lav_link">
                Features
              </Link>
            </li>
            <li className="nav_list">
              <Link to="" className="lav_link">
                Reviews
              </Link>
            </li>
            <li className="nav_list">
              <Link to="" className="lav_link">
                Business
              </Link>
            </li>
          </ul>
          <ul>
            <button className="mobile_hide">
              <FaBars className="icons" />
            </button>
            <button className="toggle_btn" onClick={handleToggle}>
              <FaBars className="icons" />
            </button>
          </ul>
        </div>
      </div>

      <section className="hero_banner">
        <div className="container">
          <div className="content">
            <div className="text_area">
              <h4>Your Lifetime of Cashflow</h4>
              <h1>
                Al Credit Repair + <br />
                <span className="color_text">Funding App</span>
              </h1>
              <p>
                Repair Your Credit, Access Maximum Funding, and Invest: Your
                All-in-One Financial Platform for Success.
                <span className="color_text"> Benefit the Rewards </span>
                Yourself or Create a Repair/ Funding Company.
              </p>
              <div className="btn_group">
                <Link to="/sign_in">
                  <button className="btn">Get Started</button>
                </Link>
                <Link to="/sign_in">
                  <button className="btn sign_in_btn">Sign In</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="video_section">
        <div className="container">
          <div className="video-container relative">
            <video
              ref={videoRef}
              src={video}
              className="video"
              onClick={handleTogglePlay}
              preload="metadata"
            />
            {/* Thumbnail overlay */}
            {!isPlaying && (
              <div className="thumbnail-overlay flex justify-center items-center">
                <img
                  src={thumbnail}
                  alt="Video Thumbnail"
                  className="thumbnail"
                />
                <div className="play-button" onClick={handleTogglePlay}>
                  <img className="icons" src={play_btn} alt="" />
                </div>
              </div>
            )}
          </div>
          <div className="brand_area">
            <h2>As Seen On</h2>
            <img src={logos} alt="Brand Logos" />
          </div>
        </div>
      </section>
      <section className="testimonial">
        <div className="container-fluid">
          <Swiper
            modules={[Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            onSwiper={(swiper) => console.log(swiper)}
            breakpoints={{
              1024: {
                slidesPerView: 5,
              },
              768: {
                slidesPerView: 3,
              },
              640: {
                slidesPerView: 2,
              },
              320: {
                slidesPerView: 1,
              },
            }}
          >
            {images.map((images, index) => (
              <SwiperSlide key={index}>
                <img src={images.timg} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <footer className="footer">
        <div className="container">
          <div className="footer_content">
            <div className="brand">
              <img className="footer_logo" src={logo_d} alt="Brand Logo" />
              <p>
                Ultimate credit repair solutions and funding services using AI,
                empowering you to achieve financial freedom.
              </p>
              <div className="social">
                <Link to="">
                  <FaFacebook className="icons" />
                </Link>
                <Link to="">
                  <FaTwitter className="icons" />
                </Link>
                <Link to="">
                  <FaInstagramSquare className="icons" />
                </Link>
                <Link to="">
                  <FaYoutube className="icons" />
                </Link>
              </div>
            </div>
            <ul className="footer_menu">
              <li>
                <Link to="">Home</Link>
              </li>
              <li>
                <Link to="">How it works</Link>
              </li>
              <li>
                <Link to="">Features</Link>
              </li>
            </ul>
            <ul className="footer_menu">
              <li>
                <Link to="">Terms & Services</Link>
              </li>
              <li>
                <Link to="">Privacy Policy</Link>
              </li>
              <li>
                <Link to="">Disclaimer</Link>
              </li>
            </ul>
          </div>
          <hr className="my-4" />
          <p className="text-center">2024 Casso, Inc. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
